import { render } from "./SuperAdminProfileUserTable.vue?vue&type=template&id=d13cb560&scoped=true"
import script from "./SuperAdminProfileUserTable.vue?vue&type=script&lang=js"
export * from "./SuperAdminProfileUserTable.vue?vue&type=script&lang=js"

import "./SuperAdminProfileUserTable.vue?vue&type=style&index=0&id=d13cb560&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d13cb560"]])

export default __exports__